<template>
  <div class="hold-transition">
    <loading v-if="cargando" />
    <div class="wrapper">
      <div class="content-wrapper">
        <section class="content-header">
          <div class="container-fluid">
            <div class="row">
              <div class="col-sm-6">
                <h5 class="mb-0">Precintos</h5>
              </div>
              <div class="col-sm-6">
                <ol class="breadcrumb float-sm-right">
                  <li class="breadcrumb-item">
                    <router-link to="/">Home</router-link>
                  </li>
                  <li class="breadcrumb-item active">Argentina</li>
                  <li class="breadcrumb-item active">Administración</li>
                  <li class="breadcrumb-item active">Precintos</li>
                </ol>
              </div>
            </div>
          </div>
        </section>

        <div class="container-fluid">
          <div class="card">
            <div class="card-header pt-2 pb-2">
              <div class="row justify-content-between">
                <div class="btn-group">
                  <button
                    type="button"
                    class="btn bg-gradient-dark border-dark"
                    data-toggle="modal"
                    data-target="#modal-form-rank"
                    style="cursor: pointer"
                    v-if="$store.getters.can('argentina.precintos.create')"
                    @click="$refs.PrecintoRangos.limpiarModal()"
                  >
                    Rangos de Precintos
                    <i class="fab fa-hackerrank"></i>
                  </button>
                </div>

                <div class="btn-group">
                  <button
                    type="button"
                    class="btn btn-primary"
                    data-toggle="modal"
                    data-target="#modal-precinto_individual"
                    style="cursor: pointer"
                    @click="$refs.PrecintoIndividual.resetForm()"
                    v-if="$store.getters.can('argentina.precintos.create')"
                  >
                    <i class="fas fa-plus"></i>
                  </button>
                </div>

                <div class="btn-group">
                  <button
                    type="button"
                    class="btn bg-gradient-info border-info"
                    @click="getIndex(), getGrafica()"
                  >
                    <i class="fas fa-sync-alt"></i>
                  </button>
                  <button
                    type="button"
                    class="btn bg-gradient-danger border-danger"
                    @click="resetFilter(), getGrafica()"
                  >
                    <i class="fas fa-broom"></i>
                  </button>
                </div>
              </div>
            </div>

            <div class="card-body pb-2">
              <div class="row justify-content-center">
                <div class="form-group col-md-2">
                  <label>Número de Precinto</label>
                  <input
                    type="text"
                    v-model="filtros.numero"
                    placeholder="Numero de precinto"
                    label="numero"
                    class="form-control form-control-sm"
                    @keyup.enter="getIndex()"
                  />
                </div>
                <div class="form-group col-md-2">
                  <label>N° Remito</label>
                  <input
                    type="text"
                    v-model="filtros.remito"
                    placeholder="N° Remito"
                    label="remito"
                    class="form-control form-control-sm"
                    @keyup.enter="getIndex()"
                  />
                </div>

                <div class="form-group col-md-3">
                  <label>Transportadora</label>
                  <v-select
                    v-model="slct_transportadora"
                    class="form-control form-control-sm p-0"
                    placeholder="Razón Social"
                    label="razon_social"
                    :options="listasForms.transportadoras"
                    @input="getIndex()"
                  ></v-select>
                </div>

                <div class="form-group col-md-1">
                  <label>Vehículo</label>
                  <input
                    type="text"
                    class="form-control form-control-sm"
                    v-model="filtros.placa"
                    @keyup="getIndex()"
                  />
                </div>

                <div class="form-group col-md-1">
                  <label>Remolque</label>
                  <input
                    type="text"
                    class="form-control form-control-sm"
                    v-model="filtros.remolque"
                    @keyup="getIndex()"
                  />
                </div>

                <div class="form-group col-md-3">
                  <label>Fecha</label>
                  <input
                    type="date"
                    class="form-control form-control-sm"
                    v-model="filtros.fecha"
                    @keyup="getIndex()"
                  />
                </div>

                <div class="form-group col-md-2">
                  <label>Estado</label>
                  <select
                    class="form-control form-control-sm"
                    v-model="filtros.estado"
                    @change="getIndex()"
                  >
                    <option value="">Seleccione...</option>
                    <option
                      v-for="estadoPrecinto in listasForms.estados"
                      :key="estadoPrecinto.numeracion"
                      :value="estadoPrecinto.numeracion"
                    >
                      {{ estadoPrecinto.descripcion }}
                    </option>
                  </select>
                </div>
              </div>
            </div>

            <div class="card-body table-responsive p-0">
              <table
                id="precintos"
                class="table table-bordered table-striped table-hover table-sm text-nowrap"
                style="font-size: 0.85em"
              >
                <thead class="bg-dark">
                  <tr>
                    <th class="col-1">Número de precinto</th>
                    <th class="col-1">Número de remito</th>
                    <th class="col-2">Transportadora</th>
                    <th>Vehículo</th>
                    <th>Remolque</th>
                    <th>Destino</th>
                    <th>Fecha</th>
                    <th>Estado</th>
                    <th>Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in precintos.data" :key="item.id">
                    <td>{{ item.numero }}</td>

                    <td v-if="item.viaje && item.viaje.remito != null">
                      {{ item.viaje.remito.numero }}
                    </td>
                    <td v-else>{{ " " }}</td>

                    <td>
                      {{
                        item.viaje != null && item.viaje != undefined
                          ? item.viaje.transportadora.razon_social
                          : ""
                      }}
                    </td>
                    <td>
                      {{
                        item.viaje != null && item.viaje != undefined
                          ? item.viaje.vehiculo.placa
                          : ""
                      }}
                    </td>
                    <td>
                      {{
                        item.viaje != null &&
                        item.viaje != undefined &&
                        item.viaje.remolque
                          ? item.viaje.remolque.placa
                          : ""
                      }}
                    </td>
                    <td>
                      {{
                        item.viaje != null && item.viaje != undefined
                          ? item.viaje.sitioDescargue
                            ? item.viaje.sitioDescargue.nombre
                            : ""
                          : ""
                      }}
                    </td>
                    <td>{{ item.created_at ? item.created_at.slice(0, 10) : "" }}</td>
                    <td class="text-center">
                      <div v-if="item.estado == 1">
                        <h6>
                          <span
                            class="badge badge-success"
                            data-toggle="modal"
                            data-target="#modal-form-estado"
                            @click="llenarModal(item.id, item.estado)"
                            style="cursor: pointer"
                            ><i class="fas fa-check-circle"></i>
                            {{ item.estadoPrecinto }}</span
                          >
                        </h6>
                      </div>
                      <div v-else-if="item.estado == 2">
                        <h6>
                          <span class="badge badge-primary"
                            ><i class="far fa-check-circle"></i>
                            {{ item.estadoPrecinto }}</span
                          >
                        </h6>
                      </div>
                      <div v-else-if="item.estado == 3">
                        <h6>
                          <span class="badge badge-warning"
                            ><i class="fas fa-times-circle"></i>
                            {{ item.estadoPrecinto }}</span
                          >
                        </h6>
                      </div>
                      <div v-else>
                        <h6>
                          <span class="badge badge-danger"
                            ><i class="far fa-times-circle"></i>
                            {{ item.estadoPrecinto }}</span
                          >
                        </h6>
                      </div>
                    </td>
                    <td class="text-right">
                      <div class="btn-group">
                        <button
                          class="btn btn-info"
                          v-if="$store.getters.can('argentina.precintos.show')"
                          data-toggle="modal"
                          data-target="#modal-ver-precinto"
                          @click="verPrecinto(item)"
                        >
                          <i class="fas fa-eye"></i>
                        </button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="card-footer">
              <div class="float-left" v-if="precintos.total">
                <p>
                  Mostrando del <b>{{ precintos.from }}</b> al
                  <b>{{ precintos.to }}</b> de un total:
                  <b>{{ precintos.total }}</b> Registros
                </p>
              </div>
              <div class="float-left" v-else>
                <p>
                  <span class="badge badge-danger">
                    No hay registros para mostrar
                  </span>
                </p>
              </div>
              <pagination
                :data="precintos"
                @pagination-change-page="getIndex"
                :limit="10"
                align="right"
              ></pagination>
            </div>
          </div>
        </div>
        <div class="col-md-12">
          <div class="row">
            <div class="col-lg-3">
              <div class="small-box bg-secondary">
                <div class="inner">
                  <h3 style="font-size: 50px">Precintos</h3>
                  <h3 style="font-size: 15px">
                    Disponibles:
                    <span class="badge badge-pill badge-success">{{
                      cantidadDisp
                    }}</span>
                  </h3>
                  <h3 style="font-size: 15px">
                    Usados:
                    <span class="badge badge-pill badge-primary">{{
                      cantidadUsa
                    }}</span>
                  </h3>
                  <h3 style="font-size: 15px">
                    Anulados:
                    <span class="badge badge-pill badge-warning">{{
                      cantidadAnu
                    }}</span>
                  </h3>
                  <h3 style="font-size: 15px">
                    Extraviados:
                    <span class="badge badge-pill badge-danger">{{
                      cantidadExt
                    }}</span>
                  </h3>
                </div>
                <div class="icon">
                  <i class="ion ion-pie-graph"></i>
                </div>
                <a href="#" class="small-box-footer"></a>
              </div>
            </div>
            <div class="col-lg-3">
              <div class="small-box bg-light">
                <pie-chart
                  :data="chartData"
                  :options="chartOptions"
                ></pie-chart>
              </div>
            </div>
          </div>
        </div>
      </div>

      <PrecintoEstado ref="PrecintoEstado" />
      <PrecintoRangos ref="PrecintoRangos" />
      <PrecintoIndividual ref="PrecintoIndividual" />

      <!-- Modal Ver Precinto -->
      <div class="modal fade" id="modal-ver-precinto">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header bg-geogo-top-left pt-2 pb-2">
              <h4 class="modal-title text-white">Detalles del Precinto</h4>
              <button
                type="button"
                class="close text-white"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="row" v-if="precintoSeleccionado">
                <div class="col-md-6">
                  <p><strong>Número:</strong> {{ precintoSeleccionado.numero }}</p>
                </div>
                <div class="col-md-6">
                  <p><strong>Estado:</strong> {{ precintoSeleccionado.estadoPrecinto }}</p>
                </div>
                <div class="col-md-6">
                  <p><strong>Fecha de Creación:</strong> {{ precintoSeleccionado.created_at ? precintoSeleccionado.created_at.slice(0, 10) : '' }}</p>
                </div>
                <div class="col-md-6" v-if="precintoSeleccionado.justificacion">
                  <p><strong>Justificación:</strong> {{ precintoSeleccionado.justificacion }}</p>
                </div>
                
                <!-- Información del Viaje -->
                <div class="col-md-12 mt-3" v-if="precintoSeleccionado.viaje">
                  <h5>Información del Viaje</h5>
                  <hr>
                </div>
                <div class="col-md-6" v-if="precintoSeleccionado.viaje && precintoSeleccionado.viaje.remito">
                  <p><strong>Número de Remito:</strong> {{ precintoSeleccionado.viaje.remito.numero }}</p>
                </div>
                <div class="col-md-6" v-if="precintoSeleccionado.viaje && precintoSeleccionado.viaje.transportadora">
                  <p><strong>Transportadora:</strong> {{ precintoSeleccionado.viaje.transportadora.razon_social }}</p>
                </div>
                <div class="col-md-6" v-if="precintoSeleccionado.viaje && precintoSeleccionado.viaje.vehiculo">
                  <p><strong>Vehículo:</strong> {{ precintoSeleccionado.viaje.vehiculo.placa }}</p>
                </div>
                <div class="col-md-6" v-if="precintoSeleccionado.viaje && precintoSeleccionado.viaje.remolque">
                  <p><strong>Remolque:</strong> {{ precintoSeleccionado.viaje.remolque.placa }}</p>
                </div>
                <div class="col-md-6" v-if="precintoSeleccionado.viaje && precintoSeleccionado.viaje.sitioDescargue">
                  <p><strong>Destino:</strong> {{ precintoSeleccionado.viaje.sitioDescargue.nombre }}</p>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal">
                Cerrar
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import pagination from "laravel-vue-pagination";
import vSelect from "vue-select";
import PrecintoEstado from "./PrecintoEstado";
import PrecintoRangos from "./PrecintoRangos";
import PrecintoIndividual from "./PrecintoIndividual";
import PieChart from "../../../hidrocarburos/administrativo/PieChart.js";
import Loading from "../../../../components/Loading";

export default {
  name: "Precintos",
  components: {
    Loading,
    pagination,
    vSelect,
    PrecintoEstado,
    PrecintoRangos,
    PrecintoIndividual,
    PieChart,
  },
  data() {
    return {
      chartOptions: {
        hoverBorderWidth: 20,
      },
      animation: {
        animateRotate: false,
        animateScale: true,
      },
      chartData: {
        hoverBorderWidth: 10,
        labels: ["Disponibles", "Usados", "Anulados", "Extraviados"],
        datasets: [
          {
            backgroundColor: ["#00C851", "#0099CC", "#ffbb33", "#ff4444"],
            borderWidth: 2,
          },
        ],
      },
      filtros: {},
      slct_transportadora: [],
      precintos: {},
      precintoSeleccionado: null,
      listasForms: {
        transportadoras: [],
        estados: [],
      },
      cargando: false,
      cantidadDisp: "",
      cantidadUsa: "",
      cantidadAnu: "",
      cantidadExt: "",
    };
  },
  methods: {
    getIndex(page = 1) {
      let me = this;
      me.cargando = true;
      this.filtros.transportadora_id = this.slct_transportadora
        ? this.slct_transportadora.id
        : null;

      axios
        .get("/api/argentina/precintos?page=" + page, {
          params: this.filtros,
        })
        .then(function (response) {
          me.precintos = response.data.precintos;
          me.cargando = false;
        })
        .catch(function (error) {
          me.cargando = false;
          console.error("Error al cargar precintos:", error);
        });
    },

    async getGrafica() {
      let me = this;
      me.cargando = true;
      this.filtros.transportadora_id = this.slct_transportadora
        ? this.slct_transportadora.id
        : null;

      axios
        .get("/api/argentina/precintos/graficas", {
          params: this.filtros,
        })
        .then(function (response) {
          me.cargando = false;
          me.cantidadDisp = response.data.cantDisp || 0;
          me.cantidadUsa = response.data.cantUsa || 0;
          me.cantidadAnu = response.data.cantAnu || 0;
          me.cantidadExt = response.data.cantExt || 0;
          me.chartData.datasets[0].data[0] = me.cantidadDisp;
          me.chartData.datasets[0].data[1] = me.cantidadUsa;
          me.chartData.datasets[0].data[2] = me.cantidadAnu;
          me.chartData.datasets[0].data[3] = me.cantidadExt;
        })
        .catch(function (error) {
          me.cargando = false;
          console.error("Error al cargar gráficas:", error);
        });
    },

    getTransportadoras() {
      let me = this;
      me.listasForms.transportadoras = [];
      var url = "api/argentina/empresas/lista";
      axios
        .get(url, {
          params: { pais_id: 3 }, // Filtrar por país 3 (Argentina)
        })
        .then(function (response) {
          let respuesta = response.data;
          me.listasForms.transportadoras = respuesta;
        })
        .catch(function (error) {
          console.error("Error al cargar transportadoras:", error);
        });
    },

    getEstados() {
      axios.get("/api/lista/37").then((response) => {
        this.listasForms.estados = response.data;
      });
    },

    resetFilter() {
      this.slct_transportadora = null;
      this.filtros = {};
      this.getIndex();
    },

    llenarModal(id, estado) {
      this.$refs.PrecintoEstado.llenar_modal(id, estado);
    },

    verPrecinto(item) {
      this.precintoSeleccionado = item;
    },

    getMsg() {
      if (this.$route.params.msg) {
        this.$swal({
          icon: "success",
          title: this.$route.params.msg,
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 4000,
          timerProgressBar: true,
        });
      }
    },
  },

  beforeMount() {
    this.getEstados();
    this.getTransportadoras();
  },
  mounted() {
    this.getIndex();
    this.getGrafica();
  },
};
</script>
